export const GALLERY = [
  {
    id: "g4",
    url: "/images/gallery/g4.jpg",
    title: "VW Multivan Boden",
    category: "auto",
  },
  {
    id: "g2",
    url: "/images/gallery/g2.jpg",
    title: "Sofa Reinigung",
    category: "furniture",
  },
  {
    id: "g3",
    url: "/images/gallery/g3.jpg",
    title: "VW Golf Interior",
    category: "auto",
  },
  {
    id: "g1",
    url: "/images/gallery/g1.jpg",
    title: "VW Multivan Boden",
    category: "auto",
  },
  {
    id: "g5",
    url: "/images/gallery/g5.jpg",
    title: "Tiefenreinigung Matratze",
    category: "furniture",
  },
  {
    id: "g6",
    url: "/images/gallery/g6.jpg",
    title: "Tiefenreinigung Matratze",
    category: "furniture",
  },
  {
    id: "g7",
    url: "/images/gallery/g7.jpg",
    title: "Mercedes S-Class",
    category: "auto",
  },
  {
    id: "g8",
    url: "/images/gallery/g8.jpg",
    title: "Mercedes S-Class",
    category: "auto",
  },
  {
    id: "g9",
    url: "/images/gallery/g9.jpg",
    title: "WV Passat b7",
    category: "auto",
  },
  {
    id: "g10",
    url: "/images/gallery/g10.jpg",
    title: "WV Passat b7",
    category: "auto",
  },
  {
    id: "g11",
    url: "/images/gallery/g11.jpg",
    title: "Dodge Jorny",
    category: "auto",
  },
  {
    id: "g12",
    url: "/images/gallery/g12.jpg",
    title: "Dodge Jorny",
    category: "auto",
  },
  {
    id: "g13",
    url: "/images/gallery/g13.jpg",
    title: "Mercedes V-Class",
    category: "auto",
  },
  {
    id: "g14",
    url: "/images/gallery/g14.jpg",
    title: "Mercedes V-Class",
    category: "auto",
  },
  {
    id: "g15",
    url: "/images/gallery/g15.jpg",
    title: "Mercedes V-Class",
    category: "auto",
  },
  {
    id: "g16",
    url: "/images/gallery/g16.jpg",
    title: "Mercedes V-Class",
    category: "auto",
    },

];

export const REVIEWS = [
  {
    id: "r1",
    name: "Markus H.",
    rating: 5,
    date: "2026-04-30",
    text: {
      de: "Absolut top! Mein Auto sieht aus wie neu. Termin war pünktlich, Arbeit war sauber und schnell erledigt. Klare Empfehlung.",
      ua: "Просто супер! Авто виглядає як нове. Майстер приїхав вчасно, робота зроблена чисто та швидко. Рекомендую.",
    },
  },
  {
    id: "r2",
    name: "Julia S.",
    rating: 5,
    date: "2026-04-25",
    text: {
      de: "Unser Sofa war nach Jahren wieder wie gekauft. Super Service bei uns zu Hause — keine Umstände, faire Preise.",
      ua: "Диван після років знову як новий. Чудовий сервіс у нас удома — жодних незручностей, чесні ціни.",
    },
  },
  {
    id: "r3",
    name: "Oleksii K.",
    rating: 5,
    date: "2026-04-22",
    text: {
      de: "Matratze wurde perfekt gereinigt, Flecken komplett weg. Sehr professionell und freundlich.",
      ua: "Матрац почистили ідеально, плям немає зовсім. Дуже професійно і привітно.",
    },
  },
  {
    id: "r4",
    name: "Sandra B.",
    rating: 5,
    date: "2026-04-28",
    text: {
      de: "Premium Paket fürs Auto gebucht — jedes Detail wurde gereinigt, Dachhimmel, Sitze, Teppich. Bester Detailer in Wien!",
      ua: "Взяла Premium пакет для авто — почистили кожну деталь, стелю, сидіння, килим. Найкращий детейлер у Відні!",
    },
  },
];
